import { ProductAdsComponent } from '@/scopes/product-ads/components/ProductAds'
import { ProductAdsList } from '@/scopes/product-ads/components/ProductAdsList'
import { useProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import cn from 'classnames'
import { useRef } from 'react'
import styles from './HomeTile.module.css'

interface ProductAdsProps {
  contextItemId: string
  headerTitle?: string | null
  infoLabel?: string | null
  infoContent?: string | null
  className?: string
}

function HomeTileProductAds({
  contextItemId,
  headerTitle,
  infoLabel,
  infoContent,
  className,
}: ProductAdsProps) {
  const productAdsRef = useRef<HTMLDivElement>(null)
  const { data = [], isLoading } = useProductAds({
    contextItemId,
    componentType: 'LandingList',
  })

  useProductAdsListViewed(data, 'sponsored_home', productAdsRef)

  if (!data.length)
    return null

  return (
    <div ref={productAdsRef} className={cn(styles.wrapper, className)} data-qa="product-ads">
      <div className={styles.background} />
      <ProductAdsComponent
        infoLabel={infoLabel}
        infoContent={infoContent}
        headerTitle={headerTitle}
      >
        <ProductAdsList
          data={data}
          isLoading={isLoading}
          type="sponsored_home"
        />
      </ProductAdsComponent>
    </div>
  )
}

export { HomeTileProductAds }
